module.exports = __webpack_public_path__ + "img/bidding.3de1d7bd.png";